
import { Vue, Component } from 'vue-property-decorator';
import { UserModule } from '@/store/modules/user';

@Component
export default class EmailLogin extends Vue {
  private email = '';

  private password = '';

  private rememberMe = false;

  mounted() {
    // 저장된 이메일 불러오기
    const savedEmail = localStorage.getItem('savedEmail');
    if (savedEmail) {
      this.email = savedEmail;
      this.rememberMe = true;
    }
  }

  private goBack() {
    this.$router.go(-1);
  }

  private async handleLogin() {
    if (!this.email) {
      this.$message.warning('이메일을 입력해주세요.');
      return;
    }

    if (!this.password) {
      this.$message.warning('비밀번호를 입력해주세요.');
      return;
    }

    try {
      // 아이디 저장 처리
      if (this.rememberMe) {
        localStorage.setItem('savedEmail', this.email);
      } else {
        localStorage.removeItem('savedEmail');
      }

      // 이메일 로그인 API 호출
      await UserModule.EmailLogin({ email: this.email, password: this.password });

      this.$message.success('로그인 성공');
      this.$router.push({ name: 'Home' });
    } catch (error: any) {
      this.$message.error('로그인에 실패했습니다.');
      console.error(error);
    }
  }

  private findId() {
    this.$router.push({ name: 'FindId' });
  }

  private findPassword() {
    this.$router.push({ name: 'FindPassword' });
  }

  private register() {
    this.$router.push({ name: 'Register' });
  }
}
